// @flow

import * as React from 'react';

type Props = {|
  /** The callback function to execute */
  trigger: () => any,
  /** The number of milliseconds before execution */
  interval: number,
|};

/**
 * A timer for executing a callback function after a specified number of milliseconds
 */
export default class Timer extends React.Component<Props> {
  componentDidMount() {
    this.timeStart = setTimeout(() => this.props.trigger(), this.props.interval);
  }

  componentWillUnmount() {
    clearTimeout(this.timeStart);
  }

  timeStart: any;

  render() {
    return null;
  }
}

export { default as Interval } from './Interval';
